/**
 * DevExtreme (ui/data_grid/ui.data_grid.virtual_columns.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var gridCore = require("./ui.data_grid.core"),
    virtualColumnsModule = require("../grid_core/ui.grid_core.virtual_columns");
gridCore.registerModule("virtualColumns", virtualColumnsModule);



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.virtual_columns.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.virtual_columns.js
// module chunks = common